// Gate de ruta para Liquidaciones: complementa el ocultamiento en el
// AdminSidebar (E2) para que un admin sin finance_access tampoco pueda
// entrar tipeando la URL directamente (E4). La autoridad real sigue siendo
// requireAdminPermit("finance_access") en el backend — esto solo evita
// renderizar la pantalla del lado del cliente.
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function RequireFinanceAccess() {
  const { financeAccess, capabilitiesLoading } = useAuth();

  if (capabilitiesLoading) {
    return null;
  }

  if (!financeAccess) {
    return <Navigate to="/admin" replace />;
  }

  return <Outlet />;
}
